<template>
    <div id="deals-wrapper">
        <div class="deals-wrapper-item" v-for="index in numberOfBoxes" :key="index">
            <span href="#" class="deals-wrapper-dealbox deal-box-wrapper deal-blurred shimmer-container">
                <div class="deal-box-img-container blur-box shimmer">
                    
                </div>
                <div class="deal-box-desc">
                    <div class="shimmer shimmer-text"></div>
                    <div class="shimmer shimmer-text"></div>
                    <div class="shimmer shimmer-text"></div>
                </div>
                <div class="deal-box-prices desktop-only">
                    <div class="shimmer shimmer-text"></div>
                    <div class="shimmer shimmer-text"></div>
                </div>
                <div class="deal-box-button-container blur">
                    <button disabled class="button">Deal Details</button>
                </div>
                <div class="blur">
                    <img class="amzn-img" alt="Amazon logo" :src="'https://' + settings.baseDomain + '/assets/img/amazon-logo-640.png'">
                </div>
            </span>
        </div>
    </div>

</template>

<script>
    import settings from '@/settings'
    export default {
        data() {
            return {
                numberOfBoxes: 16
            }
        },
        computed: {
            settings: function () { return settings; }
        }
    }
</script>